import React from 'react';
import { Building2, Zap, Plane, Truck, DollarSign, Newspaper, Cpu, ShoppingCart } from 'lucide-react';

// Centralized icon mapping for all 8 subsidiaries
export const subsidiaryIconMap = {
  smartland: Building2,
  smartmart: ShoppingCart,
  smartinvest: DollarSign,
  smartmedias: Newspaper,
  smartenergies: Zap,
  smartlogistics: Truck,
  smartaviation: Plane,
  smartlab: Cpu,
};

/**
 * Branded icon badge for a subsidiary.
 * Renders a colored circular/rounded square with the company's Lucide icon.
 * Replaces the previous low-resolution logo thumbnails for a clean, consistent look.
 */
const SubsidiaryIcon = ({ subsidiary, size = 'md', shape = 'rounded' }) => {
  const Icon = subsidiaryIconMap[subsidiary.id] || Building2;

  const sizeMap = {
    sm: { box: 'w-10 h-10', icon: 'w-5 h-5' },
    md: { box: 'w-14 h-14', icon: 'w-7 h-7' },
    lg: { box: 'w-20 h-20', icon: 'w-10 h-10' },
    xl: { box: 'w-24 h-24', icon: 'w-12 h-12' },
  };
  const s = sizeMap[size] || sizeMap.md;
  const radius = shape === 'circle' ? 'rounded-full' : 'rounded-2xl';

  return (
    <div
      className={`${s.box} ${radius} flex items-center justify-center flex-shrink-0 relative overflow-hidden`}
      style={{
        background: `linear-gradient(135deg, ${subsidiary.color}33 0%, ${subsidiary.color}11 100%)`,
        border: `1px solid ${subsidiary.color}55`,
        boxShadow: `0 0 24px -8px ${subsidiary.color}66`,
      }}
      data-testid={`subsidiary-icon-${subsidiary.id}`}
    >
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background: `radial-gradient(circle at 30% 30%, ${subsidiary.color}55 0%, transparent 70%)`,
        }}
      />
      {subsidiary.customIcon ? (
        <img
          src={subsidiary.customIcon}
          alt={subsidiary.name}
          className={`${s.icon} relative z-10 object-contain`}
          style={{ width: '70%', height: '70%' }}
        />
      ) : (
        <Icon className={`${s.icon} relative z-10`} style={{ color: subsidiary.color }} strokeWidth={2} />
      )}
    </div>
  );
};

export default SubsidiaryIcon;
